import { FC } from 'react'
import { useField } from 'react-final-form'

import TextField, {
  Props as TextFieldProps,
} from '~/form/components/molecules/TextField'

type Props = Pick<TextFieldProps, 'isConfirm' | 'required'>

const NAME = 'tel'

const TelField: FC<Props> = (props) => {
  const {
    input: { value },
  } = useField(NAME)

  if (props.isConfirm && !value) return null

  return (
    <TextField
      type={NAME}
      name='tel'
      ariaLabel='電話番号'
      label='電話番号'
      placeholder='09012345678'
      helperText='ハイフン(-)なしで入力してください'
      {...props}
      validate={(value) => {
        if (!value) return
        if (!/^(0{1}\d{9,10})$/.test(value)) {
          return `電話番号の形式に誤りがあります`
        }
      }}
    />
  )
}

TelField.displayName = 'tel'

export default TelField
